import { Component, OnDestroy } from '@angular/core';
import { LoaderService } from '@stockcare-services/loader-service/loader.service';
import { Subscription } from 'rxjs';
@Component({
  standalone: false,
  selector: 'app-progress-bar-loader',
  templateUrl: './progress-bar-loader.component.html',
  styleUrls: ['./progress-bar-loader.component.scss'],
})
export class ProgressBarLoaderComponent implements OnDestroy {
  subscriptions = new Subscription();
  isLoading: boolean = false;
  constructor(private loaderService: LoaderService) {
    this.subscriptions.add(
      this.loaderService.isLoading.subscribe((isLoading) => {
        setTimeout(() => {
          this.isLoading = isLoading;
        }, 0);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
